import { IPromise } from 'angular';

import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { Module } from '../../ts/Module';
import { DeleteWorkbookVersionsRequest } from '../../ts/ServerApi/requests/DeleteWorkbookVersionsRequest';
import { GetWorkbookVersionsRequest, IGetWorkbookVersionsResult } from '../serverApi/requests/getWorkbookVersionsRequest';
import { IWorkbookRevision } from '../serverApi/types/IWorkbookRevision';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToast, WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { FetcherFactory } from '../../ts/services/FetcherFactory';
import { Resource } from '../../ts/resources/Resource';

export class WorkbookRevisions extends Resource<IWorkbookRevision>  {

  public static $inject = ['FetcherFactory'];


  constructor(FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetWorkbookVersionsRequest,
      (result: IGetWorkbookVersionsResult) => result.versions));
  }

  public del = (id: string): IPromise<IResult> => {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeleteWorkbookVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

}

Module.instance().service('WorkbookRevisions', WorkbookRevisions);
